import { AttachFileOutlined, DescriptionOutlined, SpeakerNotesOff, Download, ExpandMore, FileDownloadOutlined } from '@mui/icons-material';
import {
    Box,
    Grid,
    IconButton,
    List,
    ListItem,
    Tabs,
    Tab,
    CircularProgress,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    ListItemIcon,
    ListItemText,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Divider,
    ListSubheader,
} from '@mui/material';
import React, { useState } from 'react';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { Transition } from '../pages/internal/ReturnSubmission';
import { Form, Formik } from 'formik';
import TextInput from './common/TextInput';
import { getDocument } from '../redux/api/workflows';
import { returnCasesToFIsWithTask } from '../redux/api/workflows';
import { openBase64 } from '../util';
import DocumentInput from './common/DocumentInput';

export const DrawerOptions = ['Case Details', 'Conversations', 'Mails', 'Re-Submission History'];

export const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box className="h-100">{children}</Box>}
        </div>
    );
};

const CaseDetails = ({ caseDetails, defaultTab = 0, selectionModel = [], setSelectionModel, institutions = [], showReportedInstitutions = false, init }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [conversationTab, setConversationTab] = useState(0);
    const [caseDetailsDrawer, setCaseDetailsDrawer] = useState(0);
    const [caseDrawer, setCaseDrawer] = useState(defaultTab);
    const defMessage = { subject: '', message: '', attachment: '' };
    const [messageModal, setMessageModal] = useState(false);

    const downloadFile = async (docId, fileName = '') => {
        try {
            await getDocument(docId, fileName);
            enqueueSnackbar('Document Successfully');
        } catch (err) {
            enqueueSnackbar(err?.message || 'Error: Case Escalation Failed', {
                variant: 'error',
            });
        } finally {
        }
    };

    const sendMessage = async (values, { resetForm }) => {
        try {
            const formData = new FormData();

            formData.append('message', values.message);
            selectionModel?.forEach((id, key) => {
                formData.append(`caseIds[${key}]`, id);
            });
            formData.append('attachments[0][fileDescription]', values?.attachment?.name || '');
            formData.append('attachments[0][internalUseOnly]', true);
            formData.append('attachments[0][attachmentDocument]', values?.attachment);
            const resp = await returnCasesToFIsWithTask(formData);

            if (resp.isSuccess) {
                enqueueSnackbar(resp.message);
                setMessageModal(false);
                setSelectionModel([]);
                resetForm();
                init && init(caseDetails.caseId);
            } else {
                enqueueSnackbar(resp.message, { variant: 'error' });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={caseDrawer} onChange={(_, newValue) => setCaseDrawer(newValue)}>
                    {DrawerOptions.map((label, key) => (
                        <Tab label={label} key={key} />
                    ))}
                </Tabs>
            </Box>
            <Box padding={3} className="flex-1 d-flex flex-direction-column pt-05 pl-05">
                <TabPanel value={caseDrawer} index={0}>
                    <List className="upload-details">
                        <ListItem>
                            <b>Tracking Reference Number: </b> {caseDetails?.trackingReferenceNumber}
                        </ListItem>
                        <ListItem>
                            <b>Unique Identification No: </b> {caseDetails?.uniqueIdentificationNo}
                        </ListItem>
                        <ListItem>
                            <b>Case ID: </b> {caseDetails?.caseId}
                        </ListItem>
                        <ListItem>
                            <b>Bank: </b> {caseDetails?.institution?.name || ''}
                        </ListItem>
                        {caseDetails?.workflowId && (
                            <>
                                <ListItem>
                                    <b>Escalation Source: </b> {caseDetails?.workflow?.escalationType || ''}
                                </ListItem>
                                <ListItem>
                                    <b>Escalation Status: </b> {caseDetails?.workflow?.cbnStatus || ''}
                                </ListItem>
                            </>
                        )}
                    </List>
                    <Box sx={{ width: '100%' }}>
                        <Box
                            sx={{
                                borderBottom: 1,
                                borderColor: 'divider',
                            }}
                        >
                            <Tabs value={caseDetailsDrawer} onChange={(event, newValue) => setCaseDetailsDrawer(newValue)}>
                                <Tab label="Complaint Details" />
                                <Tab label="Complainant Details" />
                                <Tab label="Other Details" />
                                {showReportedInstitutions && <Tab label="Reported Institutions" />}
                            </Tabs>
                        </Box>
                        <TabPanel value={caseDetailsDrawer} index={0}>
                            <List className="upload-details">
                                <ListItem>
                                    <b>Subject of Complaint: </b> {caseDetails?.subjectOfComplaint}
                                </ListItem>
                                <ListItem>
                                    <b>Complaint Description: </b> {caseDetails?.complaintDescription}
                                </ListItem>
                                <ListItem>
                                    <b>Complaint Category Code: </b> {caseDetails?.complaintCategoryCode}
                                </ListItem>
                                <ListItem>
                                    <b>Complaint Category: </b> {caseDetails?.subCategory?.category?.name ? `${caseDetails?.subCategory?.category?.name ?? ''}  | ` : ''}
                                    {caseDetails?.subCategory?.name ?? ''}
                                </ListItem>
                                <ListItem>
                                    <b>Complaint Location City: </b> {caseDetails?.complaintLocationCity}
                                </ListItem>
                                <ListItem>
                                    <b>Compliant Channel: </b> {caseDetails?.compliantChannelName}
                                </ListItem>
                                <ListItem>
                                    <b>Compliant Location Branch: </b> {caseDetails?.compliantLocationBranch}
                                </ListItem>
                                <ListItem>
                                    <b>Status of Complaint: </b> {caseDetails?.statusOfComplaintName}
                                </ListItem>
                                <ListItem>
                                    <b>Account Type: </b> {caseDetails?.accountTypeName}
                                </ListItem>
                                <ListItem>
                                    <b>Account Number: </b> {caseDetails?.accountNumber}
                                </ListItem>
                                <ListItem>
                                    <b>Action Taken: </b> {caseDetails?.actionTaken}
                                </ListItem>
                                <ListItem>
                                    <b>Amount in Dispute: </b> {caseDetails?.amountInDispute}
                                </ListItem>
                                <ListItem>
                                    <b>Amount Recovered: </b> {caseDetails?.amountRecovered}
                                </ListItem>
                                <ListItem>
                                    <b>Amount Refunded: </b> {caseDetails?.amountRefunded}
                                </ListItem>
                                <ListItem>
                                    <b>Branch: </b> {caseDetails?.branchName}
                                </ListItem>
                                <ListItem>
                                    <b>Currency Code: </b> {caseDetails?.currencyCode}
                                </ListItem>
                            </List>
                        </TabPanel>
                        <TabPanel value={caseDetailsDrawer} index={1}>
                            <List className="upload-details">
                                <ListItem>
                                    <b>First Name: </b> {caseDetails?.firstName}
                                </ListItem>
                                <ListItem>
                                    <b>Last Name: </b> {caseDetails?.lastName}
                                </ListItem>
                                <ListItem>
                                    <b>Middle Name: </b> {caseDetails?.middleName}
                                </ListItem>
                                <ListItem>
                                    <b>Age of Complainant: </b> {caseDetails?.ageOfComplainant}
                                </ListItem>
                                <ListItem>
                                    <b>Cell Phone Number: </b> {caseDetails?.cellPhoneNumber}
                                </ListItem>
                                <ListItem>
                                    <b>Email Address: </b> {caseDetails?.emailAddress}
                                </ListItem>
                                <ListItem>
                                    <b>City: </b> {caseDetails?.city}
                                </ListItem>
                                <ListItem>
                                    <b>Client Type: </b> {caseDetails?.clientTypeName}
                                </ListItem>
                                <ListItem>
                                    <b>Country: </b> {caseDetails?.country}
                                </ListItem>
                                <ListItem>
                                    <b>Gender: </b> {caseDetails?.genderName}
                                </ListItem>
                                <ListItem>
                                    <b>Name of Consultant: </b> {caseDetails?.nameOfConsultant}
                                </ListItem>
                                <ListItem>
                                    <b>Office Number: </b> {caseDetails?.officeNumber}
                                </ListItem>
                                <ListItem>
                                    <b>Postal Code: </b> {caseDetails?.postalCode}
                                </ListItem>
                                <ListItem>
                                    <b>State: </b> {caseDetails?.state}
                                </ListItem>
                                <ListItem>
                                    <b>Address Line 1: </b> {caseDetails?.streetAddressLine1}
                                </ListItem>
                                <ListItem>
                                    <b>Address Line 2: </b> {caseDetails?.streetAddressLine2}
                                </ListItem>
                            </List>
                        </TabPanel>
                        <TabPanel value={caseDetailsDrawer} index={2}>
                            <List className="upload-details">
                                <ListItem>
                                    <b>Assigned By: </b> {caseDetails?.assignedBy}
                                </ListItem>
                                <ListItem>
                                    <b>Assigned User: </b> {caseDetails?.assignedUser}
                                </ListItem>
                                <ListItem>
                                    <b>CBN Status: </b> {caseDetails?.cbnStatus}
                                </ListItem>
                                {/* <ListItem><b>Created By: </b> {caseDetails?.createdBy}</ListItem> */}
                                {/* <ListItem><b>Created On: </b> {moment(caseDetails?.createdOn).format('DD MMMM, YYYY - hh:ss A')}</ListItem> */}
                                <ListItem>
                                    <b>Date Received: </b> {moment(caseDetails?.dateReceived).format('DD MMMM, YYYY')}
                                </ListItem>
                                <ListItem>
                                    <b>Date Closed: </b> {caseDetails?.dateClosed ? moment(caseDetails?.dateClosed).format('DD MMMM, YYYY') : ''}
                                </ListItem>
                                <ListItem>
                                    <b>Submission Date: </b> {moment(caseDetails?.submissionDate).format('DD MMMM, YYYY')}
                                </ListItem>
                                <ListItem>
                                    <b>FI Remarks: </b> {caseDetails?.fiRemarks}
                                </ListItem>
                                <ListItem>
                                    <b>Active: </b> {Boolean(caseDetails?.isActive) ? 'True' : 'False'}
                                </ListItem>
                                <ListItem>
                                    <b>SLA Breached: </b> {Boolean(caseDetails?.slaBreached) ? 'True' : 'False'}
                                </ListItem>
                                {/* <ListItem><b>Updated By: </b> {caseDetails?.updatedBy}</ListItem> */}
                                {/* <ListItem><b>Updated On: </b> {moment(caseDetails?.updatedOn).format('DD MMMM, YYYY - hh:ss A')}</ListItem> */}
                            </List>
                        </TabPanel>
                        <TabPanel value={caseDetailsDrawer} index={3}>
                            <List className="upload-details">
                                {caseDetails?.caseWithReportedFIs?.map(({ institutionId }, key) => {
                                    const inst = institutions?.find((inst) => inst?.institutionId == institutionId);
                                    return (
                                        <ListItem key={key}>
                                            <b>{key + 1}. </b> {inst?.name || ''}
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </TabPanel>
                    </Box>
                </TabPanel>

                <TabPanel value={caseDrawer} index={-1}>
                    <List>
                        {caseDetails?.docs?.map((doc, key) => (
                            <ListItem divider key={key}>
                                <ListItemIcon>
                                    <DescriptionOutlined />
                                </ListItemIcon>
                                <ListItemText primary={doc?.fileName || ''} secondary={doc?.fileSize ? parseFloat(parseInt(doc?.fileSize) / 1024).toFixed(2) + 'KB' : ''} />
                                <ListItemIcon className="file-download-btn" onClick={() => downloadFile(doc?.documentId || '', doc?.fileName)}>
                                    <FileDownloadOutlined />
                                </ListItemIcon>
                            </ListItem>
                        ))}
                    </List>
                </TabPanel>

                <TabPanel value={caseDrawer} index={1} style={{ height: '100%' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        className="mb-1"
                        onClick={() => {
                            setSelectionModel([caseDetails?.caseId]);
                            setMessageModal(true);
                        }}
                    >
                        Send Message
                    </Button>
                    <Box>
                        <Grid container>
                            {caseDetails?.chats
                                ?.sort((a, b) => (a?.createdOn > b?.createdOn ? -1 : 1))
                                ?.map(({ message, senderUserType, createdOn, communicationDocuments }) => (
                                    <Grid
                                        xs={12}
                                        container
                                        className="message"
                                        textAlign={senderUserType == 'CBN' ? 'right' : 'left'}
                                        justifyContent={senderUserType == 'CBN' ? 'flex-end' : 'flex-start'}
                                        flexDirection="column"
                                    >
                                        <p>{message}</p>
                                        <small>{senderUserType}</small>
                                        <small>{moment(createdOn).format('DD-MM-YYYY HH:MM:SS A')}</small>
                                        {communicationDocuments?.length > 0 && (
                                            <>
                                                <Divider className="mt-1 mb-0" />
                                                <List>
                                                    <ListSubheader
                                                        style={{
                                                            textAlign: 'left',
                                                            margin: 0,
                                                            padding: 0,
                                                            lineHeight: 1.5,
                                                        }}
                                                    >
                                                        <small>Attachments</small>
                                                    </ListSubheader>
                                                    {communicationDocuments?.map(({ document, documentId }, key) => (
                                                        <ListItem key={key} divider>
                                                            <span className="d-block mr-1">{key + 1}.</span>
                                                            <ListItemText
                                                                style={{
                                                                    overflowWrap: 'break-word',
                                                                    fontSize: '14px',
                                                                }}
                                                                primary={document.description}
                                                            />
                                                            <IconButton
                                                                onClick={() => {
                                                                    getDocument(documentId, document.fileName);
                                                                }}
                                                            >
                                                                <Download fontSize="small" />
                                                            </IconButton>
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </>
                                        )}
                                    </Grid>
                                ))}
                        </Grid>
                    </Box>
                </TabPanel>

                <TabPanel value={caseDrawer} index={2} style={{ height: '100%' }}>
                    <Box sx={{ border: 1, borderColor: 'divider' }}>
                        <Tabs centered value={conversationTab} onChange={(e, newValue) => setConversationTab(newValue)}>
                            <Tab label={'Internal'} />
                            <Tab label={'External'} />
                        </Tabs>
                    </Box>

                    <TabPanel value={conversationTab} index={0} className="">
                        {/* {JSON.stringify(caseDetails.workflow)}  publicMailConversationID */}
                        <Box className="chat-container h-100">
                            <div>
                                {Boolean(caseDetails?.workflow?.internalMailConversationID) ? (
                                    <div className="chat-messages">
                                        {caseDetails?.internalMailConversation
                                            ?.sort((a, b) => (a?.sentDateTime > b?.sentDateTime ? 1 : -1))
                                            ?.map(({ attachments = [], body, hasAttachments, sentDateTime = '', subject = '', toRecipients }, key) => (
                                                <Accordion>
                                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                                        <span className="d-block flex-1">{subject}</span>{' '}
                                                        {hasAttachments && (
                                                            <IconButton>
                                                                <AttachFileOutlined />
                                                            </IconButton>
                                                        )}
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <p
                                                            className="msg"
                                                            dangerouslySetInnerHTML={{
                                                                __html: body?.content || '',
                                                            }}
                                                        />
                                                        <small>{sentDateTime ? moment(sentDateTime).format('DD-MM-YY hh:mm:ss a') : ''}</small>
                                                        {hasAttachments && (
                                                            <>
                                                                <Divider className="mt-1 mb-1" />
                                                                <List>
                                                                    {attachments?.map(({ contentBytes, name, size, contentType }, key) => (
                                                                        <ListItem key={key} divider>
                                                                            <span className="d-block mr-1">{key + 1}.</span>
                                                                            <ListItemText
                                                                                style={{
                                                                                    overflowWrap: 'break-word',
                                                                                }}
                                                                                primary={name}
                                                                                secondary={`${parseFloat(size / 1024).toFixed(2)} KB`}
                                                                            />
                                                                            <IconButton onClick={() => openBase64(contentBytes, contentType, name)}>
                                                                                <Download />
                                                                            </IconButton>
                                                                        </ListItem>
                                                                    ))}
                                                                </List>
                                                            </>
                                                        )}
                                                    </AccordionDetails>
                                                </Accordion>
                                            ))}
                                    </div>
                                ) : (
                                    <div className="empty d-flex d-flex flex-direction-column justify-content-center align-items-center">
                                        <SpeakerNotesOff
                                            className="mt-2 mb-05"
                                            style={{
                                                fontSize: '50px',
                                            }}
                                            color="primary"
                                        />
                                        <p>No Conversations</p>
                                        {/* <Button fullWidth variant="outlined" onClick={() => setShowAddAction(true)}>
                                                        Start Conversation
                                                    </Button> */}
                                    </div>
                                )}
                            </div>
                        </Box>
                    </TabPanel>

                    <TabPanel value={conversationTab} index={1} className="">
                        <Box className="chat-container h-100">
                            <div>
                                {Boolean(caseDetails?.workflow?.publicMailConversationID) ? (
                                    <div className="chat-messages">
                                        {caseDetails?.publicMailConversation
                                            ?.sort((a, b) => (a?.sentDateTime > b?.sentDateTime ? 1 : -1))
                                            ?.map(({ attachments = [], body, hasAttachments, sentDateTime = '', subject = '', toRecipients }, key) => (
                                                <Accordion>
                                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                                        <span className="d-block flex-1">{subject}</span>{' '}
                                                        {hasAttachments && (
                                                            <IconButton>
                                                                <AttachFileOutlined />
                                                            </IconButton>
                                                        )}
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <p
                                                            className="msg"
                                                            dangerouslySetInnerHTML={{
                                                                __html: body?.content || '',
                                                            }}
                                                        />
                                                        <small>{sentDateTime ? moment(sentDateTime).format('DD-MM-YY hh:mm:ss a') : ''}</small>
                                                        {hasAttachments && (
                                                            <>
                                                                <Divider className="mt-1 mb-1" />
                                                                <List>
                                                                    {attachments?.map(({ contentBytes, name, size, contentType }, key) => (
                                                                        <ListItem key={key} divider>
                                                                            <span className="d-block mr-1">{key + 1}.</span>
                                                                            <ListItemText
                                                                                style={{
                                                                                    overflowWrap: 'break-word',
                                                                                }}
                                                                                primary={name}
                                                                                secondary={`${parseFloat(size / 1024).toFixed(2)} KB`}
                                                                            />
                                                                            <IconButton onClick={() => openBase64(contentBytes, contentType, name)}>
                                                                                <Download />
                                                                            </IconButton>
                                                                        </ListItem>
                                                                    ))}
                                                                </List>
                                                            </>
                                                        )}
                                                    </AccordionDetails>
                                                </Accordion>
                                            ))}
                                    </div>
                                ) : (
                                    <div className="empty d-flex d-flex flex-direction-column justify-content-center align-items-center">
                                        <SpeakerNotesOff
                                            className="mt-2 mb-05"
                                            style={{
                                                fontSize: '50px',
                                            }}
                                            color="primary"
                                        />
                                        <p>No Conversations</p>
                                        {/* <Button fullWidth variant="outlined" onClick={() => setShowAddAction(true)}>
                                                        Start Conversation
                                                    </Button> */}
                                    </div>
                                )}
                            </div>
                        </Box>
                    </TabPanel>
                </TabPanel>

                <TabPanel value={caseDrawer} index={3} className="">
                    <Box>
                        {caseDetails?.caseHistory?.map((updateHistory, key) => (
                            <div key={key}>
                                <Accordion className="mb-1">
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <div
                                            style={{
                                                flex: 1,
                                                margin: '.5rem 0',
                                            }}
                                        >
                                            Status: {updateHistory.status}
                                            <p className="mb-0 mt-0">{moment(updateHistory.createdOn).format('DD MMM, YYYY')}</p>
                                        </div>
                                        {/* <Chip color={moment(updateHistory?.createdOn).diff(moment(), 'days') < 0 ? 'error' : 'warning'} className='mr-05' size='small' label={'Deadline: ' + } /> */}
                                    </AccordionSummary>
                                    <AccordionDetails className="pt-0">
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>S/N</TableCell>
                                                    <TableCell>Field</TableCell>
                                                    <TableCell>Old Value</TableCell>
                                                    <TableCell>New Value</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {updateHistory.changes.map((change, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{change?.fieldName}</TableCell>
                                                        <TableCell>{change?.oldValue}</TableCell>
                                                        <TableCell>{change?.newValue}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </AccordionDetails>
                                </Accordion>
                                {key + 1 !== caseDetails?.caseHistory?.length && (
                                    <div className="d-flex flex-direction-column align-items-center">
                                        <div className="dashed-border" />
                                    </div>
                                )}
                            </div>
                        ))}
                    </Box>
                </TabPanel>
            </Box>

            <Dialog open={Boolean(messageModal)} TransitionComponent={Transition} keepMounted maxWidth="lg" disableEscapeKeyDown>
                <Formik initialValues={{ ...defMessage }} onSubmit={sendMessage}>
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent style={{ minWidth: '50vw' }}>
                                {selectionModel?.map((cs, index) => (
                                    <Grid container key={index} alignItems="center" className="mt-05 mb-05" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextInput readOnly value={cs} id="caseID" label="Case ID" />
                                        </Grid>
                                    </Grid>
                                ))}
                                <Divider className="mt-2 mb-0" />
                                <Grid container alignItems="center" className="mt-05 mb-05" spacing={2}>
                                    <Grid item xs={12}>
                                        <TextInput id="message" required label="Message" minRows={2} multiline />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <DocumentInput id="attachment" label="Attachment" />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className="p-2  pb-1 pr-2">
                                <Button onClick={() => setMessageModal(false)} disabled={isSubmitting} variant="contained" color="secondary">
                                    Cancel
                                </Button>

                                <Button type="submit" disabled={isSubmitting} variant="contained" color="primary">
                                    {isSubmitting ? <CircularProgress size={15} /> : 'Send'}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default CaseDetails;
